import React from "react";
import { useTranslation } from "react-i18next";

import { getDisplayedAmount } from "@utils";
import { AccStatementBetSlipEventInOffer } from "@data-types/account-statement/AccountStatementBetSlip";

export function AdditionalGainTax(props: {
	slipDetails: AccStatementBetSlipEventInOffer;
}) {
	const t = useTranslation().t;

	if (!props.slipDetails.gainTaxPercentage) {
		return null;
	}

	return (
		<tr className="table--bets__tr">
			<td className="table--bets__dd">
				{t<string>("ACC_STATEMENT.BET_DETAILS.ADDITIONAL_GAIN_TAX", {
					0: props.slipDetails.gainTaxPercentage.toFixed(),
				})}
			</td>
			<td className="table--bets__dd">
				- {getDisplayedAmount(props.slipDetails.gainTax || 0, "", 0)}
			</td>
		</tr>
	);
}
